'use client';
import { usePathname } from 'next/navigation';
import * as React from 'react';

import AuthLayout from '@/layouts/AuthLayout';

export default function layout({ children }: { children: React.ReactNode }) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const pathName = usePathname();

  if (pathName === '/verify-email') {
    return <>{children}</>;
  }

  return <AuthLayout>{children}</AuthLayout>;
}
